
import {map, filter, withLatestFrom, switchMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CustomerApi, CustomersApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { CAAction } from '../actions/index';
import { Customers, CustomerFiles, RESPONSE_FILE_UPLOAD_COMPLETE } from '../actions/index';
import * as selectors from '../reducers/index';
import { MatDialog } from '@angular/material';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';

const of = Observable.of;

@Injectable()
export class CustomerFilesEffects {
  @Effect()
  assignFileToCustomer = this.actions$
    .ofType(RESPONSE_FILE_UPLOAD_COMPLETE).pipe(
    filter(action => action.payload.type === 'customer'),
    withLatestFrom(this.store.select(selectors.getSelectedId('customers'))),
    switchMap(([action, id]) =>
      this.customerApi
        .addFile(id, action.payload.response)
        .map(res => Customers.ResponseSuccessAddCustomerFile(res))
        .catch(err => of(Customers.ResponseFailAddCustomerFile))
    ),);

  @Effect()
  removeFileFromCustomer = this.actions$
    .ofType(CustomerFiles.REQUEST_DESTROY_BY_ID).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId('customers'))),
    switchMap(([action, id]) =>
      this.dialog
        .open(ConfirmationDialogComponent, {
          data: {
            title: 'Remove File?',
            body: 'Are you sure you want to remove this file? This can not be undone',
            confirm: 'Delete',
            cancel: 'Cancel',
            confirmColor: 'warn'
          }
        })
        .afterClosed().pipe(
        map(result => [action, id, result]))
    ),
    switchMap(
      ([action, id, result]) =>
        result
          ? this.customerApi
              .removeFile(id, action.payload.id)
              .map(res => CustomerFiles.ResponseSuccessDestroyByIdAction(action.payload))
              .catch(err => of(CustomerFiles.ResponseFailDestroyByIdAction(err)))
          : of(CustomerFiles.ResponseFailDestroyByIdAction())
    ),);

  constructor(
    private store: Store<any>,
    private actions$: Actions<CAAction>,
    private adminApi: CustomerApi,
    private customerApi: CustomersApi,
    private dialog: MatDialog
  ) {}
}
